/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Credit_AppliedInputs */

const vi_order_credit_applied = /** @type {(inputs: Order_Credit_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã trừ vào số dư khách`)
};

/**

* @param {Order_Credit_AppliedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_credit_applied = /** @type {((inputs?: Order_Credit_AppliedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Credit_AppliedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_credit_applied(inputs)
});